import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { CleanClassBadge } from './partials';
export var FundCleanClassBadge = function FundCleanClassBadge(_ref) {
  var product = _ref.product;
  var hasCleanClass = product.entity.commercializations.some(function (_ref2) {
    var security = _ref2.security;
    return security && security.clean;
  });
  if (hasCleanClass) {
    return React.createElement(CleanClassBadge, null, "Clase Limpia");
  }
  return null;
};